<template>
  <v-flex v-if="accountFields">
    <v-row v-for="(field, i) in accountFields" :key="field.id">
      <v-col>
        <h5 class="section-title pb-2">{{ field.title }}</h5>
        <validated-field
          v-slot="{ attrs }"
          :name="field.title"
          v-model="accountFields[field.id].value"
          :validator="$v.accountFields[field.id] ? $v.accountFields[field.id].value : $v"
        >
          <v-select
            outlined
            filled
            dense
            height="44"
            single-line
            hide-no-data
            hide-details
            v-if="field.type === 'select'"
            v-bind="attrs"
            v-model="accountFields[field.id].value"
            :items="field.values"
            label=""
          >
            <template v-bind="attrs" v-if="attrs.hasErrors" v-slot:append>
              <error-tooltip-auto :errors="attrs.errorMessages" />
            </template>
          </v-select>
          <v-text-field
            outlined
            filled
            single-line
            dense
            height="44"
            hide-details
            v-else
            v-bind="attrs"
            v-model="accountFields[field.id].value"
            label=""
          >
            <template v-bind="attrs" v-if="attrs.hasErrors" v-slot:append>
              <error-tooltip-auto :errors="attrs.errorMessages" />
            </template>

            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs: attributes }">
                  <v-fade-transition>
                    <v-icon
                      class="mt-1"
                      v-bind="attributes"
                      v-on="on"
                      small
                      :class="{ 'validation-icon': attrs.hasErrors, 'info-icon': !attrs.hasErrors }"
                    >
                      mdi-information-outline
                    </v-icon>
                  </v-fade-transition>
                </template>
                <div class="d-flex flex-column">
                  <span v-if="accountFields[field.id].validation.required">
                    {{ $t('components.bookingForm.validation.required') }}
                  </span>
                </div>
              </v-tooltip>
            </template>
          </v-text-field>
        </validated-field>
        <v-divider class="my-6 mb-0" v-if="i + 1 < accountFields.length" />
      </v-col>
    </v-row>

    <v-flex class="mt-4 d-flex justify-space-between">
      <v-btn color="#333333" outlined @click="onBackClick">
        {{ $t("components.bookingForm.back") }}
      </v-btn>

      <v-btn :disabled="$v.accountFields.$invalid" color="#333333" class="white--text" depressed @click="onAccountStepSubmit">
        {{ $t("components.bookingForm.book") }}
      </v-btn>
    </v-flex>
  </v-flex>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "AccountFieldsStepComponent",
  props: {
    presenter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      account: null,
      accountFields: [],
    };
  },
  async created() {
    this.accountFields = this.presenter.interactor.bookingFormModel.accountFields.reduce(
      (result, field) => {
        if (field.active) result[field.id] = field; // eslint-disable-line no-param-reassign
        return result;
      },
      {}
    );
  },
  methods: {
    onBackClick() {
      this.presenter.onBackClick();
    },
    onAccountStepSubmit() {
      this.presenter.onAccountStepSubmit(this.accountFields);
    },
  },
  validations() {
    return {
      accountFields: Object.entries(this.accountFields).reduce((acc, [_, field]) => {
        if (field.validation?.required) {
          acc[field.id] = { value: { required } };
        }
        return acc;
      }, {}),
    };
  },
};
</script>

<style scoped></style>
